import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import { Animated } from 'react-native';

import { isWeb } from '@/shared/utils/platform';

type RotatableViewProps = {
  changeRotation: boolean;
  /**
   * Array of two allowed deg values, e.g. ['0deg', '180deg']
   */
  rotationValues?: string[];
} & PropsWithChildren;

export const RotatableView: FC<RotatableViewProps> = ({
  changeRotation,
  rotationValues = ['0deg', '180deg'],
  children
}) => {
  // Note: web does not support const spinValue = useAnimatedValue(0);
  const spinValue = useState(new Animated.Value(0))[0];
  const spinDeg = spinValue.interpolate({
    inputRange: [0, 1],
    outputRange: rotationValues
  });

  useEffect(
    () =>
      Animated.spring(spinValue, {
        toValue: changeRotation ? 1 : 0,
        // The native animated module does not exist on web — fall back to the
        // JS driver there instead of triggering the RN warning.
        useNativeDriver: !isWeb
      }).start(),
    [changeRotation, spinValue]
  );

  return (
    <Animated.View
      style={{ transform: [{ rotate: spinDeg }, { perspective: 1000 }] }}
    >
      {children}
    </Animated.View>
  );
};
